import { useEffect } from 'react';
import { useLocation } from 'react-router';

/** Quanto tempo insistir procurando a âncora — as páginas carregam sob demanda. */
const SEARCH_WINDOW_MS = 3000;

/**
 * O roteador troca a URL sem tocar na rolagem. Aqui, a cada navegação: com `#âncora`,
 * rola até o elemento (insistindo por alguns segundos, porque as páginas carregam sob
 * demanda); sem âncora, volta ao topo. `behavior: 'auto'` deixa o CSS decidir — é o
 * `scroll-behavior: smooth` do layout, desligado por `prefers-reduced-motion`.
 *
 * Depende da `key` da navegação, não só da URL: clicar de novo no mesmo atalho (a URL já
 * em `#servicos`, a pessoa lá embaixo) tem que rolar outra vez.
 */
export function useHashScroll() {
  const { key, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    const id = decodeURIComponent(hash.slice(1));
    const deadline = performance.now() + SEARCH_WINDOW_MS;
    let frame = 0;

    const scroll = () => {
      const target = document.getElementById(id);

      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      } else if (performance.now() < deadline) {
        frame = requestAnimationFrame(scroll);
      }
    };

    scroll();

    return () => cancelAnimationFrame(frame);
  }, [key, hash]);
}
